<template>
  <v-container
    :style="$vuetify.theme.dark ? '' : 'background: #eeeeee'"
    style="min-height: 100vh"
  >
    <v-row class="mb-1">
      <v-col cols="12">
        <h2 class="mt-1">
          <span class="grey--text">{{ $t("about.title") }}</span>
        </h2>
      </v-col>
      <!-- <v-col offset="7" md="2" class="mt-1" style="text-align: right"> </v-col> -->
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card flat class="py-16 px-16" elevation="0">
          <v-card-text>
            <p class="text-h2">{{ $t("about.apps.title") }}</p>
            <p>{{ $t("about.apps.info") }}</p>
            <v-list dense class="py-1 my-1">
              <v-list-item
                v-for="item in apps"
                v-bind:key="item.id"
                :href="item.url"
              >
                <v-list-item-icon> {{ item.id }}. </v-list-item-icon>
                <v-list-item-subtitle> {{ item.title }}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text>
            <p class="text-h2">{{ $t("about.mission.title") }}</p>
            <p>{{ $t("about.mission.info") }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "about-page",

  data() {
    return {
      apps: [
        {
          id: 1,
          color: "orange",
          url: "https://management.quickdeliverysystem.com/login",
          year: "2020",
          title: "Quick delivery system",
          info: `Was founded by experts in software development and analysis in pexcode,  Many expert developers joined to provide the best control platform for the development and support of many emerging companies in the community, and we seek to provide the necessary facilities in the way of everyone who wants to develop the service better than that.`,
        },
        {
          id: 2,
          color: "green",
          url: "https://pexcode.com/app/",
          year: "2021",
          title: "Quick delivery",
          info: `One of the applications that the specialists in our team are working on, guiding and directing employees according to their specialization to deliver and receive applications and direct them according to the correct path.`,
        },
        {
          id: 3,
          color: "pink",
          url: null,
          year: "2021",
          title: "Quick order",
          info: `Our team works in conjunction with the development of the platform to meet the services provided by another application to create orders easily and simulate the growing demand on the platform.`,
        },
        {
          id: 4,
          color: "purple",
          url: "https://quickdeliverysystem.com/track/",
          year: "2024",
          title: "Quick Track",
          info: `Find your package ID/Number make sure you have the package ID or number handy. This information is usually provided in the confirmation email or SMS you received when you placed the package.`,
        },
        {
          id: 5,
          color: "purple",
          url: "https://trust.quickdeliverysystem.com/",
          year: "2024",
          title: "Trust clinet | Trust QDSystem",
          info: `An integrated logistics system that enables merchants to easily add parcels and integrate with shipping companies to speed up operations with precision and efficiency. The system provides real-time shipment tracking and automatically manages inventory to improve efficiency and reduce errors.`,
        },
        {
          id: 6,
          color: "orange",
          url: "https://endpoints.quickdeliverysystem.com",
          year: "2024",
          title: "Quick end points",
          info: `If you run a local business, whether small or large, you can join us and earn money.`,
        },
      ],
    };
  },
};
</script>
